var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactsNavIcon = function SvgContactsNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M5 20a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h13a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M9 14a4 4 0 0 1 8 0v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M3 16a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M1 16a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M3 9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M1 9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgContactsNavIcon;